import React, { useState, useEffect } from 'react';

import APIKeys from 'components/modules/user/api-keys';
import SessionStore from 'stores/SessionStore';

import ShipperSidebar from 'components/modules/shipper/Sidebar';
import Container from 'components/v2/container';
import LoadingCircle from 'components/ui/LoadingCircle';

const DeveloperDetails = (props) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(SessionStore.getUser());
  }, []);

  return (
    <Container>
      <div className="lg:grid lg:grid-cols-12 lg:gap-6 mt-10">
        <div className="lg:col-span-3">
          <ShipperSidebar activePage="developer" />
        </div>
        <div className="lg:col-span-9 lg:grid lg:grid-cols-12 lg:gap-6">
          {user ? (
            <APIKeys {...props} user={user} cardClassName="lg:col-span-12" />
          ) : (
            <div className="lg:col-span-12">
              <LoadingCircle />
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default DeveloperDetails;
